import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// State
import enrollmentState from './enrollment/state'
import onlineEnrollmentState from './online-enrollment/state'
import gradeLevelState from './gradelevel/state'
import paymentState from './payment/state'
import schoolYearState from './schoolyear/state'
import sectionState from './section/state'
import studentState from './student/state'
import userState from './user/state'
import enrollmentTemplateState from './enrollmenttemplate/state'
// Mutations
import enrollmentMutation from './enrollment/mutations'
import onlineEnrollmentMutation from './online-enrollment/mutations'
import gradeLevelMutation from './gradelevel/mutations'
import paymentMutation from './payment/mutations'
import schoolYearMutation from './schoolyear/mutations'
import sectionMutation from './section/mutations'
import studentMutation from './student/mutations'
import userMutation from './user/mutations'
import enrollmentTemplateMutation from './enrollmenttemplate/mutations'
// Actions
import enrollmentActions from './enrollment/actions'
import onlineEnrollmentActions from './online-enrollment/actions'
import gradeLevelActions from './gradelevel/actions'
import paymentActions from './payment/actions'
import schoolYearActions from './schoolyear/actions'
import sectionActions from './section/actions'
import studentActions from './student/actions'
import userActions from './user/actions'
import enrollmentTemplateActions from './enrollmenttemplate/actions'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({ admin: state.admin })
})

export default new Vuex.Store({
  state: {
    ...enrollmentState,
    ...gradeLevelState,
    ...paymentState,
    ...schoolYearState,
    ...sectionState,
    ...studentState,
    ...userState,
    ...enrollmentTemplateState,
    ...onlineEnrollmentState
  },
  mutations: {
    ...enrollmentMutation,
    ...gradeLevelMutation,
    ...paymentMutation,
    ...sectionMutation,
    ...schoolYearMutation,
    ...studentMutation,
    ...userMutation,
    ...enrollmentTemplateMutation,
    ...onlineEnrollmentMutation
  },
  actions: {
    ...enrollmentActions,
    ...gradeLevelActions,
    ...paymentActions,
    ...schoolYearActions,
    ...sectionActions,
    ...studentActions,
    ...userActions,
    ...enrollmentTemplateActions,
    ...onlineEnrollmentActions
  },
  plugins: [vuexLocal.plugin]
})
